export const createColumns = (items, itemsPerColumn, maxColumns) => {
  const columns = [];
  for (let i = 0; i < items.length; i += itemsPerColumn) {
    columns.push(items.slice(i, i + itemsPerColumn));
  }
  return maxColumns && columns.length > maxColumns 
    ? columns.slice(0, maxColumns) 
    : columns;
};

export const calculateContainerWidth = (itemColumns, minColumnsInView, columnWidth) => {
  const gapWidth = 16;
  const padding = 32;
  
  if (itemColumns.length <= minColumnsInView) {
    return itemColumns.length * columnWidth + (itemColumns.length - 1) * gapWidth + padding;
  }
  
  const fullColumnsWidth = minColumnsInView * columnWidth;
  const gapsWidth = (minColumnsInView - 1) * gapWidth;
  const partialColumnWidth = Math.min(50, columnWidth * 0.3);
  
  return fullColumnsWidth + gapsWidth + partialColumnWidth + padding;
};

export const getPositionX = (event) => 
  event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;

export const getTransformValue = (isDragging, globalActiveInstance, instanceId, currentTranslate, currentSlide, columnWidth) => {
  if (isDragging && globalActiveInstance === instanceId) {
    return currentTranslate;
  }
  const GAP = 16; // Gap between columns
  const slideTransform = currentSlide * (columnWidth + GAP);
  return isNaN(slideTransform) ? 0 : slideTransform;
};
